import { Component, Inject, Input, OnDestroy, OnInit } from "@angular/core";

import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { Subscription } from "rxjs";

import { OptionItem } from "@hermes/aphrodite/fields";
import {
    FindYourSize,
    MeasurementSystemSizeComparisonTable,
} from "@hermes/api-model-product";

import { LOCALE } from "@hermes/app-core";
import { Locale } from "@hermes/locale";

import { UnitTypeService } from "../../services/unit-type.service";

import {
    filterTablesToShowOnlySelectedCountry,
    findDefaultSelectedCountry,
} from "./find-your-size.helper";

@Component({
    selector: "h-find-your-size",
    templateUrl: "./find-your-size.component.html",
    styleUrl: "./find-your-size.component.scss",
})
export class FindYourSizeComponent implements OnInit, OnDestroy {
    @Input({ required: true })
    public findYourSize!: FindYourSize;

    public selectedCountry!: string | undefined;

    public countryListOption!: OptionItem[];

    public selectLocationtForm!: FormGroup;
    public subscription: Subscription = new Subscription();

    public tablesData!: MeasurementSystemSizeComparisonTable;

    public isSizeLocationsEmpty: boolean = true;

    constructor(
        @Inject(LOCALE) private locale: Locale,
        private fb: FormBuilder,
        private unitTypeService: UnitTypeService,
    ) {}

    public ngOnInit() {
        const countryList = Object.keys(this.findYourSize.sizeLocations);
        this.isSizeLocationsEmpty = countryList.length === 0;
        // If size locations are empty there will never be the possibility to filter table datas
        if (this.isSizeLocationsEmpty) {
            this.tablesData = this.findYourSize.sizeComparisonTable;
        } else {
            this.selectedCountry = findDefaultSelectedCountry(
                this.locale.countryCode,
                this.findYourSize.defaultSizeLocation ?? "",
                countryList,
            );
            this.updateTablesDataAndUnit(this.selectedCountry, countryList);
            this.createForm(countryList);
            this.onLocationChange(countryList);
        }
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private createForm(countryList: string[]) {
        this.selectLocationtForm = this.fb.group({
            sizeLocation: new FormControl(this.selectedCountry, [
                Validators.required,
            ]),
        });

        this.countryListOption = countryList.map((country) => ({
            value: country,
            text: country,
        }));
    }

    private updateTablesDataAndUnit(
        selectedCountry: string | undefined,
        countryList: string[],
    ) {
        if (selectedCountry) {
            this.tablesData = filterTablesToShowOnlySelectedCountry(
                this.findYourSize.sizeComparisonTable,
                selectedCountry,
                countryList,
            );
            const unit = this.findYourSize.sizeLocations[selectedCountry];
            if (unit) {
                this.unitTypeService.selectedUnit$.next(unit);
            }
        } else {
            this.tablesData = this.findYourSize.sizeComparisonTable;
        }
    }

    private onLocationChange(countryList: string[]) {
        const sizeLocationControl =
            this.selectLocationtForm.get("sizeLocation");
        if (sizeLocationControl) {
            this.subscription.add(
                sizeLocationControl.valueChanges.subscribe(
                    (selectedValue: string) => {
                        this.updateTablesDataAndUnit(
                            selectedValue,
                            countryList,
                        );
                    },
                ),
            );
        }
    }
}
